module.exports = __webpack_public_path__ + "img/IMG_1366.a5ed82cb.jpg";